import { type Organization } from '@/models/account-management/Organization';
import { type Brand } from '@/models/account-management/Brand';
import { type User } from '@/models/account-management/User';
import { createApiResource } from '../adminApi';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

export const organizationApi = {
    ...createApiResource<Organization, string>('account-management/organizations'),
    listBrands: async (id: string): Promise<Brand[]> => {
        const response = await fetch(`${BASE_URL}/account-management/organizations/${id}/brands`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        const data = await response.json().catch(() => null);
        if (!response.ok) throw new HttpError(response.status, data);
        return data as Brand[];
    },
    listBrandsBySlug: async (slug: string, includeLocations: boolean): Promise<Brand[]> => {
        const response = await fetch(`${BASE_URL}/account-management/organizations/slugs/${slug}/brands?includeLocations=${includeLocations}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });
        const data = await response.json().catch(() => null);
        if (!response.ok) throw new HttpError(response.status, data);
        return data as Brand[];
    },
    inviteUser: async (id: string, user: User): Promise<void> => {
        const response = await fetch(`${BASE_URL}/account-management/organizations/${id}/users`, {
            method: 'POST',
            body: JSON.stringify(user),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getJwt()}`
            },
        });

        const contentType = response.headers.get('content-type') ?? '';
        const data = contentType.includes('json') ? await response.json().catch(() => null) : await response.text().catch(() => '');

        if (!response.ok) throw new HttpError(response.status, data);       
    }};